import { render, staticRenderFns } from "./RepresentativeInfo.vue?vue&type=template&id=2923b1a9&scoped=true"
import script from "./RepresentativeInfo.vue?vue&type=script&lang=js"
export * from "./RepresentativeInfo.vue?vue&type=script&lang=js"
import style0 from "./RepresentativeInfo.vue?vue&type=style&index=0&id=2923b1a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2923b1a9",
  null
  
)

export default component.exports